export function validateName(name: string) {
  return 0 < name.length;
}
export function validatePhone(phone: string) {
  const pattern = /^0\d{9,10}$/;
  return pattern.test(phone);
}
export function validateMail(mail: string) {
  const pattern = /[\w\-._]+@[\w\-._]+\.[A-Za-z]+/;
  return pattern.test(mail);
}
